import state from './moduleAdminState.js'
import mutations from './moduleAdminMutations.js'
import actions from './moduleAdminActions.js'
import getters from './moduleAdminGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
